<template>
  <div class="device-list-detail-dialog">
    <div class="table-bd">
      <custom-table
        index
        :data="tableData"
        :tableCode="tableCode"
        @input="selectionChange"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
      ></custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
        layout="total, prev, pager, next"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    siteId: [Number, String]
  },
  data() {
    return {
      tableCode: 'route_device_list_detail',
      data: [
      ],
      totalRows: 0,
      formSearch: {
        pageNum: 1,
        pageSize: 20
      }
    };
  },
  computed: {
    // 分页数据
    tableData() {
      const data = [...this.data];
      return data.splice(
        (this.formSearch.pageNum - 1) * this.formSearch.pageSize,
        this.formSearch.pageSize
      );
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // hlcSlotDeviceList
    getList() {
      const url = `${apis.hlcSlotDeviceList}/${this.siteId}`;
      this.$getJSON(url, {}).then((res) => {
        this.data = res.data;
        this.totalRows = res.data.length;
      });

    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
    }
  },
  created() { },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss">
.device-list-detail-dialog {
  height: 400px;
  display: flex;
  flex-direction: column;
}
</style>
